import { render, staticRenderFns } from "./LeadSection.vue?vue&type=template&id=9495bd8e&scoped=true&"
import script from "./LeadSection.vue?vue&type=script&lang=ts&"
export * from "./LeadSection.vue?vue&type=script&lang=ts&"
import style0 from "./LeadSection.vue?vue&type=style&index=0&id=9495bd8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9495bd8e",
  null
  
)

export default component.exports